import { Outlet } from 'react-router-dom';
import { Box } from '@mui/joy';
import { NotificationProvider } from '../../contexts/NotificationContext';
import NotificationContainer from '../../components/NotificationContainer';

export const AccountingApp = () => (
  <NotificationProvider>
    <NotificationContainer />
    <Box sx={{ width: '100%', minWidth: 0, p: { xs: 1.5, md: 3 } }}>
      <Outlet />
    </Box>
  </NotificationProvider>
);
